import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { PurchaseRequisitionStatusEnum } from './PurchaseRequistionStatusEnum';

export class PurchaseRequisitionStatus {
    constructor(private readonly _status: PurchaseRequisitionStatusEnum) {}

    public get value(): PurchaseRequisitionStatusEnum {
        return this._status;
    }

    public get statusText(): string {
        switch (this._status) {
            case PurchaseRequisitionStatusEnum.APPROVED:
                return marker('freigegeben');
            case PurchaseRequisitionStatusEnum.REJECTED:
                return marker('abgelehnt');
            case PurchaseRequisitionStatusEnum.PENDING:
                return marker('Freigabe ausstehend...');
            case PurchaseRequisitionStatusEnum.WITHDRAWN:
                return marker('zurückgezogen');
        }
    }

    public get textColor(): string {
        switch (this._status) {
            case PurchaseRequisitionStatusEnum.APPROVED:
                return 'success';
            case PurchaseRequisitionStatusEnum.REJECTED:
                return 'danger';
            case PurchaseRequisitionStatusEnum.PENDING:
                return 'info';
            case PurchaseRequisitionStatusEnum.WITHDRAWN:
                return 'warning';
        }
    }

    public equals(status: PurchaseRequisitionStatusEnum): boolean {
        return this._status === status;
    }
}
